/**
 * @author Sebastiano Lovatin <sebastiano@gestionaleauto.com>
 */
const sign = require('jwt-encode');
/**
 * Function that create jwt from leadId
 * @param leadId {int}
 * @return {string}
 */
const getToken = (leadId) => {
  const secret = 'Babbeo12#_#';
  const data = {
    lead_id: leadId,
  };
  const jwt = sign(data, secret, { expiresIn: '10000' });
  return jwt;
};

// eslint-disable-next-line import/prefer-default-export
export { getToken };
